import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_SESSION_PERMISSION,
  LOAD_SESSION_PERMISSION,
} from 'state/actionTypes';

export const login = (username, password) => ({
  type: LOGIN,
  payload: { username, password },
});

export const loginSuccess = payload => ({
  type: LOGIN_SUCCESS,
  payload: {
    user: payload.internal_user,
    token: payload.access_token,
  },
});

export const loginFailure = () => ({
  type: LOGIN_FAILURE,
});

export const logout = () => ({
  type: LOGOUT,
});

export const setSessionPermission = permission => ({
  type: SET_SESSION_PERMISSION,
  payload: { permission },
});

export const clearSessionPermission = () =>
  setSessionPermission({
    roles: [],
    permissions: new Map(),
    resources: [],
    pages: new Set(),
  });

export const loadSessionPermission = () => ({
  type: LOAD_SESSION_PERMISSION,
});
